import { DEFAULT_LOCALE, type Enums, type Tables } from '@magicschool/supabase/types';

export const roomSharingQueryParam = 'room-sharing-id';

export const defaultRoom: Tables<'rooms'> = {
  created_at: '',
  require_login: false,
  id: '',
  join_code: '',
  name: '',
  grade_level: 'pre-k',
  state: 'active' as const,
  state_changed_at: '',
  status: 'active',
  teacher_join_code: '',
  creator_org_id: null,
  avatar_color: '',
  sharing_access_type: 'private',
  sharing_code: '',
  updated_at: '',
  edited_at: '',
  locale: DEFAULT_LOCALE,
  description: null,
  scheduled_end_at: null,
  scheduled_start_at: null,
  scheduling_enabled: false,
  locked_reason: null,
  open_days: null,
  open_start_time: null,
  open_end_time: null,
  timezone: null,
};

export const defaultRoomWithTeachers = {
  ...defaultRoom,
  room_teachers: [],
};

export const roomTeacherRoleIntlMap: Record<Enums<'room_teacher_role'>, string> = {
  administrator: 'role.administrator',
  creator: 'role.creator',
  coteacher: 'role.coteacher',
  pending: 'coteacher.pending',
  rejected: 'coteacher.rejected',
};

export type RoomBuilderError = {
  toolTitle: string;
  roomToolFormId: string;
  baseToolId: string;
};

export type DuplicateRoomData = {
  id: string;
  roomName: string;
  roomDescription?: string;
  requireLogin?: boolean;
};

export type RoomActionsModalType = 'create' | 'duplicate' | 'edit-info' | 'copy';
export type RoomSchedulingStatus = 'none' | 'not-started' | 'active' | 'ended';
